<div class="content-block">
  <div>
    <app-dynamic-form></app-dynamic-form>
  </div>
</div>